import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants";

import { useNavigate } from "react-router-dom";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";


const FeedbackMasterform = () => {
  const { id } = useParams();
  let [errors, setErrors] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteFMID, setDeleteFMID] = useState(null);
  const [deleteLineNo, setDeleteLineNo] = useState(null);
  const [typeOptions, setTypeOptions] = useState([]);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    ShowSuitablePosition: 0,
    lines: [
      {
        LineNo: 1,
        GroupCategoryLabel: "",
        GroupCategoryDescription: "",
        CandidateFeedbackCategory_183: "",
        is_inactive: true,
      },
    ],
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    fetchTypeOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchTypeOptions = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}feedback-master`);
      const jobType = response?.data?.data?.categories;
      const options = jobType.map((master) => ({
        value: master.value,
        label: master.text,
      }));
      setTypeOptions(options);
      fetchData(id);
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}feedback-master/${id}`
      );
      if (response && response.status === 200) {
        const { Code, Name, Description, ShowSuitablePosition } =
          response?.data?.data?.feedbackbackmaster || {};
        const feedbackmasterdetails =
          response?.data?.data?.feedbackmasterdetails || [];

        const lines = feedbackmasterdetails.map((version) => ({
          ID: version.ID,
          FMID: version.FMID,
          LineNo: version.LineNo,
          GroupCategoryLabel: version.GroupCategoryLabel || "",
          GroupCategoryDescription: version.GroupCategoryDescription || "",
          CandidateFeedbackCategory_183:
            version.CandidateFeedbackCategory_183 || "",
          is_inactive: true,
        }));
        setFormData({
          Code: Code,
          Name: Name,
          Description: Description,
          ShowSuitablePosition: ShowSuitablePosition === 1 ? 1 : 0,
          lines: lines,
        });
      } else {
        console.error(
          "Failed to fetch Feedback details. Server responded with status:",
          response?.status
        );
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedLines = [...formData.lines];
    updatedLines[index][name] = value;
    if (name === "GroupCategoryLabel" && value) {
      const newErrors = { ...errors };
      delete newErrors[`GroupCategoryLabel${index}`]; 
      setErrors(newErrors);
    }

    if (name === "CandidateFeedbackCategory_183" && value) {
      const newErrors = { ...errors };
      delete newErrors[`CandidateFeedbackCategory_183${index}`];
      setErrors(newErrors);
    }

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };

  const handleAddLine = () => {
    const currentRow = formData.lines[formData.lines.length - 1];
    if (
      !currentRow ||
      Object.values(currentRow).some((value) => value !== "")
    ) {
      const newLineNo = formData.lines.length + 1;
      setFormData((prevState) => ({
        ...prevState,
        lines: [
          ...prevState.lines,
          {
            LineNo: newLineNo,
            GroupCategoryLabel: "",
            GroupCategoryDescription: "",
            CandidateFeedbackCategory_183: "",
            is_inactive: true,
          },
        ],
      }));
    }
  };

  const handleDeleteLine = (index, FMID, LineNo) => {
    setDeleteIndex(index);
    setDeleteFMID(FMID);
    setDeleteLineNo(LineNo);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await PostServiceCaller(
        `${API_URL}feedback-master-details-delete/${deleteFMID}/${deleteLineNo}`,
        formData,
        "delete"
      );
      const updatedLines = formData.lines.filter((_, i) => i !== deleteIndex);
      setFormData({ ...formData, lines: updatedLines });
      toast.success("Feedback Row deleted successfully!");
      setShowDeleteModal(false); // Close the modal after deletion
    } catch (error) {
      console.error("There was an error deleting the line!", error);
    }
  };
  const handleCancel = () => {
    navigate("/feedback-master");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name) newErrors.Name = "Name is required";

    // Iterate through lines to check SubSkill
    formData.lines.forEach((line, index) => {
      if (!line.GroupCategoryLabel) {
        newErrors[`GroupCategoryLabel${index}`] = "Label is required";
      }
      if (!line.CandidateFeedbackCategory_183) {
        newErrors[`CandidateFeedbackCategory_183${index}`] = "category is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      setIsSubmitting(true);
      
        
      try {
        let response;
        if (id) {
          response = await PostServiceCaller(
            `${API_URL}feedback-master/${id}`,
            formData,
            "put"
          );
        } else {
          response = await PostServiceCaller(
            `${API_URL}feedback-master`,
            formData,
            "post"
          );
        }
  
        if (response.status === 200) {
          toast.success("Data submitted successfully");
          setFormData(initialFormData);
          setTimeout(() => {
            window.location.href = "/feedback-master";
          }, 2000);
        } else {
          console.error(
            "Failed to submit data. Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
        }
      } catch (error) {
        setIsSubmitting(false);
        console.error("Error while submitting data:", error);
        if (error.response && error.response.data && error.response.data.error) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.error("Server responded with status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      }
    }

    // let mandatory_field = ["Name", "GroupCategoryLabel"];
    // let isFormInvalid = false;

    // Validate mandatory fields
    // for (let field of mandatory_field) {
    //   let error = await validate([field], formData[field], formData);
    //   if (error.status === true) {
    //     isFormInvalid = true;
    //   }
    //   setErrors((errors) => ({
    //     ...errors,
    //     [field]: error,
    //   }));
    // }

    // Check if the current row is empty
   
  };

  return (
    <>
      <div className="nest-page">
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
              <ToastContainer />
              <Form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-6">
                        <Form.Group controlId="formSkillCode">
                          <Form.Label className="col-form-label">
                            Code
                          </Form.Label>
                          <div>
                            <Form.Control
                              type="text"
                              name="Code"
                              value={formData.Code}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  Code: e.target.value,
                                })
                              }
                              required
                              disabled
                            />
                          </div>
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group>
                          <Form.Label className="col-form-label">
                            Name <span className="required">*</span>
                          </Form.Label>
                          <div>
                            <Form.Control
                              type="text"
                              name="Name"
                              className={`form-control ${errors.Name ? "is-invalid" : ""
                              }`}
                              placeholder="Feedback Name(ex:-HR R1)"
                              value={formData.Name}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  Name: e.target.value,
                                });
                                if (e.target.value && errors.Name) {
                                  const newErrors = { ...errors };
                                  delete newErrors.Name; 
                                  setErrors(newErrors);
                                }
                              }}
                              required
                            />
                          {errors.Name && (
                          <div className="invalid-feedback">
                            {errors.Name}
                          </div>
                        )}
                          </div>
                        </Form.Group>
                      </div>
                    </div>

                    <div className="row">
                      <Form.Group controlId="formSkillDescription">
                        <Form.Label className="col-form-label">
                          Description
                        </Form.Label>
                        <div>
                          <Form.Control
                            type="textarea"
                            name="Description"
                            placeholder="Description"
                            value={formData.Description}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                Description: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <div className="d-flex gap-2">
                      <div>
                        <label
                          htmlFor="flexSwitchCheckChecked"
                          className="col-form-label"
                        >
                          <b>Suitable Position</b>
                        </label>
                      </div>
                      <div className="mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="ShowSuitablePosition"
                          id="flexSwitchCheckChecked"
                          checked={formData.ShowSuitablePosition === 1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              ShowSuitablePosition: e.target.checked ? 1 : 0,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 p-0">
                    <div className="container-fluid">
                      <div className="col-lg-12 d-flex mt-2">
                        <h3 className="heading skill-heading">
                          Feedback Details
                        </h3>
                      </div>
                      <div className="table-responsive poc-head rounded">
                        <table
                          id="poctable_head"
                          className="table table-bordered"
                        >
                          <thead className="text-center">
                            <tr>
                              <th>Sr.&nbsp;No.</th>
                              <th>
                                Label<span className="required">*</span>
                              </th>
                              <th>Description</th>
                              <th>
                                Category<span className="required">*</span>
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className="text-center">
                            {formData.lines.map((line, index) =>
                              line.is_inactive ? (
                                <tr key={line.LineNo}>
                                  <td className="text-center align-middle">
                                    {line.LineNo}
                                  </td>
                                  <td className="text-center align-middle">
                                    <input
                                      type="text"
                                      name="GroupCategoryLabel"
                                      className={`form-control ${errors[`GroupCategoryLabel${index}`] ? "is-invalid" : ""}`}
                                      value={line.GroupCategoryLabel}
                                      placeholder="Group Categories Label"
                                      onChange={(e) => handleChange(e, index)}
                                      style={{ width: "200px" }}
                                    />
                                           {errors[`GroupCategoryLabel${index}`] && (
                                  <div className="invalid-feedback">
                                    {errors[`GroupCategoryLabel${index}`]}
                                  </div>
                                )}
                                  </td>
                                  <td className="text-center align-middle">
                                    <textarea
                                      name="GroupCategoryDescription"
                                      className="form-control"
                                      value={line.GroupCategoryDescription}
                                      onChange={(e) => handleChange(e, index)}
                                      style={{ width: "200px" }}
                                    />
                                  </td>
                                  <td className="text-center align-middle">
                                    <select
                                      defaultValue={
                                        line.CandidateFeedbackCategory_183
                                      }
                                      className={`form-select ${errors[`CandidateFeedbackCategory_183${index}`] ? "is-invalid" : ""}`}
                                      aria-label="Default select example"
                                      name="CandidateFeedbackCategory_183"
                                      value={line.CandidateFeedbackCategory_183}
                                      onChange={(e) => handleChange(e, index)}
                                    >
                                      <option value="">Select</option>
                                      {typeOptions.map((option) => (
                                        <option
                                          key={option.value}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                    {errors[`CandidateFeedbackCategory_183${index}`] && (
    <div className="invalid-feedback">
      {errors[`CandidateFeedbackCategory_183${index}`]}
    </div>
  )}
                                  </td>
                                  <td className="text-center align-middle">
                                    <div
                                      type="button"
                                      onClick={() =>
                                        handleDeleteLine(
                                          index,
                                          line.FMID,
                                          line.LineNo
                                        )
                                      }
                                    >
                                      <i
                                        className="bi bi-trash"
                                        style={{ fontSize: "1.2rem" }}
                                      ></i>
                                    </div>
                                  </td>
                                </tr>
                              ) : null
                            )}
                          </tbody>
                        </table>
                        <button
                          type="button"
                          className="custom-btn mt-1 mb-2"
                          onClick={handleAddLine}
                        >
                          <i className="fa fa-plus"></i>Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-end">
                  <button className="cancel-btn me-2" onClick={handleCancel}>
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmit}
                      type="button"
                      className="custom-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <div className="card rounded border-0 m-2">
          <Modal.Header>
            <Modal.Title className="text-info">
              <div className="text-center d-flex justify-center">
                <h2 style={{ fontWeight: "800", color: "#2E2E48" }}>
                  <i className="bi bi-exclamation-triangle-fill icon"></i>{" "}
                  Delete Confirm
                </h2>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="rounded m-3"
            style={{
              maxHeight: "60vh",
              overflow: "scroll",
              backgroundColor: "white",
            }}
          >
            <p>Are you sure you want to delete this item?</p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-info "
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </button>
            <button
              className="btn custom-btn text-white"
              onClick={handleConfirmDelete}
            >
              Delete
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default FeedbackMasterform;
